import React, { useState } from "react";
import { Formik } from "formik";
import FormInput from "../../../../../components/Universal/FormInput.component";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";

const Body = () => {
  const digitalImpressions = ["Social Media", "Google Ads", "YouTube Ads"];
  const durationTypes = ["Monthly", "Quarterly", "Yearly"];
  const paymentModes = ["Cash", "Bank Transfer", "UPI", "Cheque"];
  const verifiers = ["Manager A", "Manager B", "Auditor X"];

  // Dependent options
  const paymentForOptionsMap = {
    Monthly: [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ],
    Quarterly: ["Q1", "Q2", "Q3", "Q4"],
    Yearly: ["2023", "2024", "2025"],
  };

  // local state for dynamic list
  const [paymentForOptions, setPaymentForOptions] = useState([]);

  return (
    <Formik
      initialValues={{
        impression: "",
        description: "",
        b2bPartner: "",
        contact: "",
        paymentDuration: "",
        paymentFor: "",
        totalAmount: "",
        paidAmount: "",
        gst: "",
        verifier: "",
        paymentMode: "",
      }}
      onSubmit={(values) => {
        console.log("Submitted:", values);
      }}
    >
      {({
        values,
        setFieldValue,
        handleSubmit,
        touched,
        errors,
        setTouched,
      }) => (
        <form onSubmit={handleSubmit} className="p-1">
          <div className="grid grid-cols-2 gap-4 mb-05">
            {/* Digital Impressions */}
            <DropDownInput
              name="impression"
              label="Digital impressions"
              value={values.impression}
              placeholder="Choose an impression"
              suggestionList={digitalImpressions}
              setFieldValue={(val) => setFieldValue("impression", val)}
            />

            {/* Description */}
            <FormInput
              name="description"
              label="Description"
              type="text"
              placeholder="Type something here"
              touched={touched}
              errors={errors}
              setFieldValue={(e) =>
                setFieldValue("description", e.target.value)
              }
            />

            {/* B2B Partner */}
            <FormInput
              name="b2bPartner"
              label="B2B partner/provider (if any)"
              type="text"
              placeholder="Enter name of partner"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("b2bPartner", e.target.value)}
            />

            {/* Contact */}
            <FormInput
              name="contact"
              label="Contact (if any)"
              type="text"
              placeholder="Enter phone number"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("contact", e.target.value)}
            />

            {/* Payment Duration (controls other field) */}
            <DropDownInput
              name="paymentDuration"
              label="Payment duration"
              value={values.paymentDuration}
              placeholder="Choose a duration type"
              suggestionList={durationTypes}
              setFieldValue={(val) => {
                setFieldValue("paymentDuration", val);
                setFieldValue("paymentFor", ""); // reset dependent field
                setPaymentForOptions(paymentForOptionsMap[val] || []);
              }}
            />

            {/* Payment For (depends on duration) */}
            <DropDownInput
              name="paymentFor"
              label="Payment for"
              value={values.paymentFor}
              placeholder="Choose duration to payment"
              suggestionList={paymentForOptions}
              setFieldValue={(val) => setFieldValue("paymentFor", val)}
            />

            {/* Total Amount */}
            <FormInput
              name="totalAmount"
              label="Total amount (INR)"
              type="number"
              placeholder="Enter amount"
              touched={touched}
              errors={errors}
              setFieldValue={(e) =>
                setFieldValue("totalAmount", e.target.value)
              }
            />

            {/* Paid Amount */}
            <FormInput
              name="paidAmount"
              label="Paid amount (INR)"
              type="number"
              placeholder="Enter paid amount"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("paidAmount", e.target.value)}
            />

            {/* GST */}
            <FormInput
              name="gst"
              label="GST (if any)"
              type="number"
              placeholder="Enter GST in %"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("gst", e.target.value)}
            />

            {/* Verifier */}
            <DropDownInput
              name="verifier"
              label="Verifier"
              value={values.verifier}
              placeholder="Choose payment verifier"
              suggestionList={verifiers}
              setFieldValue={(val) => setFieldValue("verifier", val)}
            />

            {/* Payment Mode */}
            <DropDownInput
              name="paymentMode"
              label="Payment mode"
              value={values.paymentMode}
              placeholder="Choose payment mode"
              suggestionList={paymentModes}
              setFieldValue={(val) => setFieldValue("paymentMode", val)}
            />
          </div>

          <button type="submit" className="actionBtn w-full mt-1">
            Collect
          </button>
        </form>
      )}
    </Formik>
  );
};

export default Body;
